"use strict";
module.exports = {
    ANDROID: 'https://play.google.com/store/apps/details?id=au.com.ahm.ahmapp',
    IOS: 'https://itunes.apple.com/au/app/ahm-health-insurance/id1371865965',
};
